import LocationOnIcon from "@mui/icons-material/LocationOn";

const SouthIndia = () => {
  return (
    <div>
      <div className="offices_div1">
        <div className="offices_div11">
          <div className="offices_div111">
            <a
              target="_blank"
              href="https://www.google.com/maps/place/BHIVE+Workspace+MG+Road/@12.9735141,77.6142341,17z/data=!3m1!4b1!4m5!3m4!1s0x3bae17daed2415b9:0x12dd81e0b4f492f2!8m2!3d12.9735089!4d77.6164228?coh=164777&entry=tt&shorturl=1"
            >
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a
                target="_blank"
                href="https://www.google.com/maps/place/BHIVE+Workspace+MG+Road/@12.9735089,77.6164228,17z/data=!3m1!4b1!4m6!3m5!1s0x3bae17daed2415b9:0x12dd81e0b4f492f2!8m2!3d12.9735089!4d77.6164228!16s%2Fg%2F11h75z6gql?entry=ttu"
              >
                Bangalore, Karnataka
              </a>
              <p>
                BeeHive Mahalakshmi Chambers, <br />
                Opp Trinity Metro Station, <br />
                MG Road, Bengaluru, <br /> Karnataka - 560 056
              </p>
            </div>
          </div>
          <div className="offices_div111">
            <a
              target="_blank"
              href="https://www.google.com/maps/place/Khalf+Coworks+-+Coworking+Space+In+Chennai/@13.0825333,80.2109558,17z/data=!3m1!4b1!4m5!3m4!1s0x3a5265cdfec9bc4b:0x230175d6ce49b8e!8m2!3d13.0825281!4d80.2131445?coh=164777&entry=tt&shorturl=1"
            >
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a
                target="_blank"
                href="https://www.google.com/maps/place/Khalf+Coworks+-+Coworking+Space+In+Chennai/@13.0825333,80.2109558,17z/data=!3m1!4b1!4m5!3m4!1s0x3a5265cdfec9bc4b:0x230175d6ce49b8e!8m2!3d13.0825281!4d80.2131445?coh=164777&entry=tt&shorturl=1"
              >
                Chennai, Tamil Nadu
              </a>
              <p>
                Suite B and I, 2nd Floor, AB-103, 105, <br />
                04th Ave, Shanthi Colony, Anna Nagar, <br />
                Chennai, <br />
                Tamil Nadu - 600 040
              </p>
            </div>
          </div>
          <div className="offices_div111">
            <a target="_blank" href="">
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a target="_blank" href="">
                Puducherry
              </a>
              <p>
                Suite No 4, Old No. 374 New No. 388, <br />
                Vazhudavur, Main road, Shanmugapuram, <br />
                Puducherry - 605 009
              </p>
            </div>
          </div>
        </div>
        <div className="offices_div11">
          <div className="offices_div111">
            <a target="_blank" href="">
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a target="_blank" href="">
                Calicut, Kerala
              </a>
              <p>
                2nd Floor, Home Land Avenue, <br />
                Puthiyara Junction, Calicut, <br />
                Kozhikode, Kerala - 673 004
              </p>
            </div>
          </div>
          <div className="offices_div111">
            <a
              target="_blank"
              href="https://www.google.com/maps/place/Awfis+Oyster+Complex,+Somajiguda,+Begumpet/@17.4301871,78.4542081,17z/data=!3m1!4b1!4m5!3m4!1s0x3bcb97f02ffabd33:0x87d219554c4803fd!8m2!3d17.430182!4d78.4563968?coh=164777&entry=tt&shorturl=1"
            >
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a
                target="_blank"
                href="https://www.google.com/maps/place/Awfis+Oyster+Complex,+Somajiguda,+Begumpet/@17.4301871,78.4542081,17z/data=!3m1!4b1!4m5!3m4!1s0x3bcb97f02ffabd33:0x87d219554c4803fd!8m2!3d17.430182!4d78.4563968?coh=164777&entry=tt&shorturl=1"
              >
                Hyderabad, Telangana
              </a>
              <p>
                3rd floor, 6-3-1112, Awfis Space Solutions, <br />
                Oyster Complex, Begumpet, Oyster Complex, <br />
                Begumpet,
                <br /> Hyderabad - 500 016
              </p>
            </div>
          </div>
          <div className="offices_div111">
            <a
              target="_blank"
              href="https://www.google.co.in/maps/place/The+Cowork+Spaces+%F0%9F%92%9E+Plug+N+Play+Offices/@17.7547206,83.287839,12.04z/data=!4m5!3m4!1s0x3a394393257969af:0x635c81ee3182300!8m2!3d17.7337384!4d83.3069162?coh=164777&entry=tt&shorturl=1"
            >
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a
                target="_blank"
                href="https://www.google.co.in/maps/place/The+Cowork+Spaces+%F0%9F%92%9E+Plug+N+Play+Offices/@17.7547206,83.287839,12.04z/data=!4m5!3m4!1s0x3a394393257969af:0x635c81ee3182300!8m2!3d17.7337384!4d83.3069162?coh=164777&entry=tt&shorturl=1"
              >
                Vishakhapatnam, Andhra Pradesh
              </a>
              <p>
                2nd Floor, D.No. 50-81-24, Flat No 301-302, <br />
                The Coworking Spaces, G V K Plaza, Seethammapeta, <br />
                Visakhapatnam,
                <br /> Andhra Pradesh - 530 016
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SouthIndia;
